import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
    selector: 'app-loading-overlay',
    standalone: true,
    imports: [CommonModule],
    styleUrls: ['./loading-overlay.component.scss'],
    templateUrl: './loading-overlay.component.html'
})
export class LoadingOverlayComponent {
    protected themeService = inject(ThemeService);
    private readonly localLogoBlack = 'assets/images/brand/logo/nibni-logo-black.avif';
    private readonly localLogoWhite = 'assets/images/brand/logo/nibni-logo-white.avif';

    @Input() message = 'Preparing your session...';
    @Input() fullscreen = true;

    get logoSrc(): string {
        const isDarkTheme = this.themeService.theme() !== 'white';
        return isDarkTheme ? this.localLogoWhite : this.localLogoBlack;
    }
}
